










































import { Component, Vue, Prop} from "vue-property-decorator";
import { Getter ,Action} from "vuex-class";
import ActivitySection from "../common/ActivitySection.vue";
import DistributeCourseDesc from "./DistributeCourseDesc.vue";
import IndexRuleIntro from "@/components/common/index/IndexRuleIntro.vue";
import InstAddress from "@/components/common/index/InstAddress.vue";
import IndexInstitutionIntroList from "@/components/common/index/IndexInstitutionIntroList.vue";
import store from '@/store';
@Component({
  components: {
    "activity-section": ActivitySection,
    "distribute-course-desc":DistributeCourseDesc,
    "index-rule-intro": IndexRuleIntro,
    "inst-address":InstAddress,
    "index-institution-intro-list": IndexInstitutionIntroList,
  }
})
export default class DistributeTabbar extends Vue {
  @Getter("section") section!: object;
  @Getter("activitySwitch") activitySwitch!: boolean;
   @Getter("activityTitle") activityTitle!: string;
  
  @Getter("institutionSwitch") institutionSwitch!: boolean;
  @Getter("institutionTitle") institutionTitle!: boolean;
  @Action("changeDistributeTabFixed") changeDistributeTabFixed!: Function;
  @Getter("distributeTabFixed") distributeTabFixed!:boolean;
  
  arrDom : any  = [];
  tabBarDom:any =[];
  activeIndex:number = 0;
  headerFixed:boolean = false;
  mounted(){
    this.tabBarDom = document.getElementsByClassName("distribute-tab-bar");
    this.arrDom = document.getElementsByClassName("tab-content-item");
    window.addEventListener('scroll', this.handleScroll);
  }
  handleScroll(){
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    this.headerFixed = scrollTop > this.tabBarDom[0].offsetTop;
    this.changeDistributeTabFixed(this.headerFixed);
    console.log('distributeTabFixed',this.distributeTabFixed);
    for (let i = 0; i < this.arrDom.length; i++) {
      if(scrollTop  <  (this.arrDom[this.arrDom.length -1].offsetTop-81)){
        if(scrollTop > (this.arrDom[i].offsetTop-81) && scrollTop < (this.arrDom[i+1].offsetTop-81)){
          this.activeIndex = i;
        }
      }else{
        this.activeIndex = this.arrDom.length -1;
      }
    }
  }
  handleSelectTab(index: number) {
    const parent:any = document.querySelector(`#app`)
    parent.scrollTo({top:this.arrDom[index].offsetTop-79,behavior: "smooth"  });
    // window.scrollTo({top:this.arrDom[index].offsetTop-79,behavior: "smooth"  });
    // this.activeIndex = index;
  }
  destroyed(){
    window.removeEventListener('scroll', this.handleScroll);

  }
}
